module.exports = __webpack_public_path__ + "static/media/swords.906fcc02.svg";